import React, { useState } from "react";
import _ from "lodash";

import ClickToCopyWrapper from "components/common/ClickToCopyWrapper";
import OpenLinkInNewWindowWrapper from "components/common/OpenLinkInNewWindowWrapper";
import UprTargetingPopover from "components/ops-mgmt/account/custom-upr/UprTargetingPopover";
import HighLightRowWrapper from "components/common/HighLightRowWrapper";
import PPLabel from "components/common/PPLabel";
import I2WLabel from "components/common/I2WLabel";
import SimpleTooltip from "components/common/SimpleTooltip";
import PropsPopover from "components/common/PropsPopover";

import FirstLookPriceSection from "./FirstLookPriceSection";

import { FiShare, FiSearch, FiFileText } from "react-icons/fi";

function FirstLookRulesTable({
  items,
  units,
  virtualPlacements,
  networkId,
  networkInfo,
  selectedItems,
  relevantLogs,
  handleSelect,
  handleCheckLog,
}) {
  const [popupId, setPopupId] = useState("");
  const networkCode = networkInfo.code;

  function handleSelectItem(itemId) {
    if (itemId === "ALL") {
      if (selectedItems.length === items.length) {
        handleSelect([]);
      } else {
        handleSelect(items.map((item) => item.externalId));
      }
    } else {
      const tempList = [...selectedItems];
      const index = tempList.indexOf(itemId);
      if (index !== -1) {
        tempList.splice(index, 1);
      } else {
        tempList.push(itemId);
      }
      handleSelect(tempList);
    }
  }

  return (
    <table className="table w-full text-sm">
      <thead className="border-b bg-gray-200 text-xs text-blue-800">
        <tr>
          <th className="px-2 text-center">
            <input
              style={{
                width: "18px",
                height: "18px",
                marginTop: "4px",
              }}
              type="checkbox"
              checked={
                items.length > 0 && selectedItems.length === items.length
              }
              onChange={() => handleSelectItem("ALL")}
            ></input>
          </th>
          <th className="border px-2 py-1 text-center ">External ID</th>
          <th className="border px-2 py-1 text-left" style={{ width: "30rem" }}>
            Name
          </th>
          <th className="border px-2 py-1 text-center ">Priority</th>
          <th className="border px-2 py-1 text-center ">Logs</th>
          <th className="border px-2 py-1 text-center ">Status</th>
          <th className="border px-2 py-1 text-center ">Type</th>
          <th className="border px-2 py-1 text-right ">Price Section</th>
          <th
            className="border px-2 py-1 text-left"
            style={{ paddingRight: "124px" }}
          >
            Targeting Section
          </th>
          <th className="border px-2 py-1 text-center">Actions</th>
        </tr>
      </thead>
      <tbody className="bg-white  text-gray-900">
        {items.map((item, i) => {
          const gamLink = `https://admanager.google.com/${networkCode}#inventory/first_look/detail/first_look_id=${item.externalId}`;

          const parsedName = item.__isI2wRule
            ? `${item.props && item.props.name ? item.props.name : ""}`
            : item.name;
          return (
            <HighLightRowWrapper
              selected={popupId === item.externalId}
              key={`${item.externalId}-${i}`}
            >
              <td className="px-2 text-center">
                <input
                  style={{
                    width: "18px",
                    height: "18px",
                    marginTop: "4px",
                  }}
                  type="checkbox"
                  checked={selectedItems.indexOf(item.externalId) !== -1}
                  onChange={() => handleSelectItem(item.externalId)}
                ></input>
              </td>
              <td className="border px-2 py-1 text-right">
                <div className="flex items-center justify-between">
                  <span
                    className={`font-mono ${
                      popupId === item.externalId ? "font-semibold" : ""
                    }`}
                  >
                    {item.externalId}
                  </span>

                  <div className="flex items-center text-blue-500">
                    <OpenLinkInNewWindowWrapper
                      href={gamLink}
                      tooltipText="Open in GAM"
                    ></OpenLinkInNewWindowWrapper>
                    <ClickToCopyWrapper
                      copyText={gamLink}
                      tooltipMessage="Click to copy GAM link"
                    ></ClickToCopyWrapper>
                  </div>
                </div>
              </td>
              <td className="border px-2 py-1 text-left">
                <div
                  className={`flex items-center justify-between ${
                    popupId === item.externalId ? "font-semibold" : ""
                  }`}
                >
                  <div className="flex items-center gap-1">
                    <I2WLabel item={item} isSmall={true}></I2WLabel>
                    {parsedName}
                    {item.__isI2wRule && (
                      <PropsPopover
                        item={item}
                        place="right"
                        resourceType="first_look"
                        onOpen={() => setPopupId(item.externalId)}
                        onClose={() => setPopupId("")}
                        triggerElement={
                          <div className="cursor-pointer text-blue-600 hover:text-blue-700">
                            <FiSearch />
                          </div>
                        }
                        titleElement={
                          <>
                            Props: {item.externalId} - {parsedName}
                            <div className="text-sm text-gray-700">
                              {item.name}
                            </div>
                          </>
                        }
                      ></PropsPopover>
                    )}
                  </div>

                  <PPLabel item={item} isSmall={true}></PPLabel>
                </div>
              </td>
              <td className="border px-2 py-1 text-center">{item.priority}</td>
              <td className="border px-2 py-1 text-center">
                {_.some(relevantLogs, ["entityId", item.externalId]) && (
                  <SimpleTooltip tooltipText="View Change Log">
                    <button
                      type="button"
                      className="flex items-center px-2 text-blue-600 hover:text-blue-700"
                      onClick={() => {
                        handleCheckLog(item.externalId);
                      }}
                    >
                      <FiFileText></FiFileText>
                    </button>
                  </SimpleTooltip>
                )}
              </td>
              <td className="border px-2 py-1 text-center">{item.status}</td>
              <td className="border px-2 py-1 text-center">{item.type}</td>
              <td className="border px-2 py-1 text-right">
                <FirstLookPriceSection
                  item={item.priceSection}
                  networkId={networkId}
                ></FirstLookPriceSection>
              </td>
              <td className="border px-2 py-1 text-left font-mono">
                <div>
                  {item.targetingSection && (
                    <UprTargetingPopover
                      id={item.externalId}
                      name={item.name}
                      networkId={networkId}
                      units={units}
                      virtualPlacements={virtualPlacements}
                      targetingSection={item.targetingSection}
                      triggerElement={
                        <div className="inline-block cursor-pointer  text-blue-600 hover:text-blue-700 hover:underline">
                          {Object.keys(item.targetingSection).join(", ")}
                        </div>
                      }
                      onOpen={() => setPopupId(item.externalId)}
                      onClose={() => setPopupId("")}
                    ></UprTargetingPopover>
                  )}
                </div>
              </td>
              <td className="border px-2 py-1 text-center text-base font-semibold text-blue-500">
                <SimpleTooltip tooltipText="Import to Custom First Look">
                  <button
                    type="button"
                    className="flex items-center px-2 hover:text-blue-700"
                    onClick={() => {
                      window.open(
                        `${window.location.origin}/#/ops-mgmt/account/network/${networkId}/first-look-setting?importId=${item.externalId}`
                      );
                    }}
                  >
                    <FiShare></FiShare>
                  </button>
                </SimpleTooltip>
              </td>
            </HighLightRowWrapper>
          );
        })}
      </tbody>
    </table>
  );
}

export default FirstLookRulesTable;
